const SSOWeb = require('@mtfe/sso-web').default;
// 线上、线下
const isProduction = (window.location.host === 'wenshu.sankuai.com' || window.location.host === 'wenshu.sec.st.sankuai.com' || window.location.host === 'wenshu.mykeeta.com');
// ClientId
const clientId = isProduction ? process.env.VUE_APP_CLIENT_ID_PROD : process.env.VUE_APP_CLIENT_ID;
// SSO HOST
const sso_host = isProduction ? 'https://ssosv.sankuai.com/sson' : 'http://ssosv.it.test.sankuai.com/sson'
// 登录URL
const login_origin = `${sso_host}/login`;
// 登出URL
const logout_origin = `${sso_host}/logout`;

export const ssoWeb = new SSOWeb({
  clientId: clientId,
  // ppe or product
  accessEnv: isProduction ? 'product' : 'test',
});

const sso = {
  doLogin() {
    //登录域名
    const {origin, href} = window.location;
    // CallBackURL
    const sso_callback_url = `${origin}/api/sso/callback`;
    const currentPath = href.replace(new RegExp(`^${origin}`), '');
    const login_url = `${login_origin}?client_id=${clientId}&redirect_uri=${encodeURIComponent(`${sso_callback_url}?original-url=${encodeURIComponent(currentPath)}`)}`;
    window.location.href = login_url;
  },
  logout() {
    const {origin, href} = window.location;
    const currentPath = href.replace(new RegExp(`^${origin}`), '');
    const sso_logout_url = `${origin}/api/sso/callback`;
    const logout_url = `${logout_origin}?client_id=${clientId}&redirect_uri=${encodeURIComponent(`${sso_logout_url}?original-url=${encodeURIComponent(currentPath)}`)}`;
    window.location.href = logout_url;
  },
}

export default sso
